export type SnapStyle = {
  scrollSnapAlign: string
  scrollSnapStop: string
}

const RESET: SnapStyle = { scrollSnapAlign: '', scrollSnapStop: '' }

export const getSnapStyle = (
  index: number,
  snapInterval: number,
): SnapStyle => {
  if (snapInterval <= 1) return RESET
  if (index % snapInterval === 0) {
    return { scrollSnapAlign: '', scrollSnapStop: 'always' }
  }
  return { scrollSnapAlign: 'none', scrollSnapStop: '' }
}
